'use client';

import * as AvatarPrimitive from '@radix-ui/react-avatar';
import * as React from 'react';
import { formatUserInitials } from 'Utils/formatUserInitials';
import { cn } from '~/lib/utils';

function Avatar({
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Root>) {
  return (
    <AvatarPrimitive.Root
      data-slot="avatar"
      className={cn(
        'relative flex size-8 shrink-0 overflow-hidden rounded-full',
        className
      )}
      {...props}
    />
  );
}

function AvatarImage({
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Image>) {
  return (
    <AvatarPrimitive.Image
      data-slot="avatar-image"
      className={cn(
        'aspect-square size-full rounded-full object-cover border-1 border-foreground',
        className
      )}
      {...props}
    />
  );
}

interface AvatarFallbackProps
  extends React.ComponentProps<typeof AvatarPrimitive.Fallback> {
  name?: string;
  delayMs?: number;
}

function AvatarFallback({
  className,
  name,
  delayMs,
  children,
  ...props
}: AvatarFallbackProps) {
  const displayContent = name ? formatUserInitials(name) : children;

  return (
    <AvatarPrimitive.Fallback
      data-slot="avatar-fallback"
      delayMs={delayMs}
      className={cn(
        'bg-foreground text-secondary-foreground text-xs flex size-full items-center justify-center rounded-full font-semibold',
        className
      )}
      {...props}
    >
      {displayContent}
    </AvatarPrimitive.Fallback>
  );
}

export { Avatar, AvatarImage, AvatarFallback };
